<template>
    <div>

        <div class="row">
            <div class="col-md-6">
                <card>
                    <img slot="image" class="card-img-top" :src="model.personal_details.profile_path"
                        alt="Card image cap" />

                </card>
            </div>

            <div class="col-md-6">
                <card>
                    <template slot="header">
                        <div class="d-flex justify-content-between">
                            <div class="p2">
                                <h3 class="card-title">{{ model.first_name + " " + model.last_name }} ({{
                                    model.personal_details.nick_name }})
                                    
                                    <span
                                        v-if="loggedInUserId == model.user_id"
                                        :class="['badge', badgeClass(model.account_status)]"
                                        style="cursor:pointer;"
                                        @click="handleBadgeClick">
                                        {{ badgeLabel(model.account_status) }}
                                    </span>
                                </h3>
                                
                            </div>
                            <div class="p2">
                                <a class="nav-link" @click="$router.push('/account/stars')" style="cursor:pointer;">
                                    <i class="tim-icons icon-pencil" id="edit-btn"
                                        style="font-size: medium; color: #fff; " v-if="loggedInUserId==model.user_id"></i>
                                </a>
                            </div>
                        </div>

                    </template>
                    <tabs>
                        <tab-pane label="Profile">

                            <li class="profile">Age <b>: {{ " " + calculateAge(model.personal_details.date_of_birth) }}
                                    years</b>
                            </li>
                            <li class="profile">Bust Size <b>: {{ " " + model.personal_details.bust_size }}</b></li>
                            <li class="profile">Hip Size <b>: {{ " " + model.personal_details.hip_size }}</b></li>
                            <li class="profile">Height <b> : {{ " " + model.personal_details.height }}</b></li>
                            <li class="profile">Hair Colour <b>: {{ " " + model.personal_details.hair_color }}</b></li>
                            <li class="profile">Location <b>: {{ " " + model.location_details.street_name }} ({{
                                model.location_details.city + " " + model.location_details.country }})</b></li>
                            <li class="profile">Availability <b>: {{ " " + model.personal_details.availability }}</b></li>
                            <li class="profile">Languages <b>: {{ " " + model.personal_details.languages }} </b></li>

                        </tab-pane>

                        <tab-pane label="Rates">

                            <li class="profile">Hourly <b>: {{ " " + model.payment_details.hourly_rate }}</b></li>
                            <li class="profile">Overnight <b>:{{ " " + model.payment_details.overnight_rate }}</b></li>

                        </tab-pane>
                        <tab-pane label="Services" class="ml-3">

                            <li class="" v-for="(value, key, index) in model.services.categories">
                                <span v-for="category in categories">
                                    <span v-if="category.id == key">{{ category.name }}</span>
                                </span>
                            </li>

                            <div v-if="loggedInUserId != model.user_id">
                                <button class="btn btn-primary" @click="openModal">Request Service</button>
                            </div>

                        </tab-pane>
                        <tab-pane label="Gallery">
                            <div class="d-flex" style="overflow: auto;">


                                <div v-for="post in posts" class="col-lg-3 col-md-3 col-3 mb-1">
                                    <a @click="$router.push('/explore')">
                                        <div class="card">
                                            <img slot="image" class="card-img-top" :src="post.url" alt="Card image cap"
                                                style="background-size: cover; width: auto; max-height: 100%;" />

                                        </div>
                                    </a>
                                </div>

                            </div>

                        </tab-pane>
                        <tab-pane label="Wallet" v-if="loggedInUserId == model.user_id">
                            <li class="profile">
                                Balance <b>: {{ walletBalance }} {{ walletCurrency }}</b>
                            </li>
                            <div class="form-group">
                                <label>Top Up Amount</label>
                                <input v-model="topUpAmount" type="number" class="form-control" placeholder="Enter amount" />
                                <button class="btn btn-success mt-2" @click="topUpWallet">Top Up</button>
                            </div>
                            <div class="form-group mt-3">
                                <label>Withdraw Amount</label>
                                <input v-model="withdrawAmount" type="number" class="form-control" placeholder="Enter amount" />
                                <button class="btn btn-warning mt-2" @click="withdrawWallet">Withdraw</button>
                            </div>
                        </tab-pane>

                    </tabs>

                </card>
            </div>
        </div>

        <modal :show.sync="showServiceModal" headerClasses="justify-content-center" modalContentClasses="modal-dark">
            <template slot="header">
                Request Service
            </template>
            <form @submit.prevent="requestService">
                <div class="alert alert-warning">
                    <b>Caution:</b> Please chat with the model and agree on the service and time before sending payment!
                </div>
                <div class="form-group">
                    <label for="service">Select Service</label>
                    <select v-model="selectedService" class="form-control" required @change="updateAmount">
                        <option v-for="(value, key) in model.services.categories" :key="key" :value="key">
                        {{ getCategoryName(key) }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="duration">Duration (hours)</label>
                    <input v-model.number="serviceDuration" type="number" min="1" class="form-control" required @input="updateAmount" />
                </div>
                <div class="form-group">
                    <label for="amount">Amount (KES)</label>
                    <input :value="serviceAmount" type="number" class="form-control" readonly />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
                    <button type="submit" class="btn btn-primary">Request & Pay</button>
                </div>
            </form>
        </modal>

        <modal :show.sync="showUpgradeModal" headerClasses="justify-content-center" modalContentClasses="modal-dark">
            <template slot="header">
                Upgrade Account
            </template>
            <div>
                <div class="alert alert-info">
                    Choose an account type and duration to upgrade:
                </div>
                <div class="form-group">
                    <label>Upgrade Type</label>
                    <select v-model="selectedUpgradeType" class="form-control">
                        <option value="vip">VIP</option>
                        <option value="premium">Premium</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Duration</label>
                    <select v-model="selectedUpgradeDuration" class="form-control">
                        <option value="1">1 Month</option>
                        <option value="3">3 Months</option>
                        <option value="6">6 Months</option>
                        <option value="12">1 Year</option>
                    </select>
                </div>
                <div class="form-group">
                    <button class="btn btn-primary btn-block" @click="upgradeAccount(selectedUpgradeType, selectedUpgradeDuration)">
                        Upgrade & Pay
                    </button>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="showUpgradeModal = false">Cancel</button>
                </div>
            </div>
        </modal>

    </div>
</template>
<script>
import { TabPane, Tabs, Modal } from 'src/components';
import { api_url, datumMixin } from '../../env';


export default {
    name: "ModelProfile",
    mixins: [datumMixin],
    components: {
        TabPane,
        Tabs,
        Modal
    },
    data() {
        return {
            id: 0,
            user_id: 0,
            loggedInUserId: 0,
            model: [],
            categories: [],
            posts: [],
            walletBalance: 0,
            walletCurrency: 'KES',
            topUpAmount: '',
            withdrawAmount: '',
            selectedService: '',
            serviceDuration: 1,
            serviceAmount: '',
            showServiceModal: false,
            showUpgradeModal: false,
            selectedUpgradeType: 'vip',
            selectedUpgradeDuration: '1',
        };
    },
    methods: {
        getModel() {
            let headers = {
                "Authorization": "Bearer " + localStorage.getItem('token'),

            };

            this.$http.get(api_url + '/models/' + this.id, { headers })
                .then(response => {
                    return response.json()
                }, response => {
                    return response
                })
                .then(response => {
                    if (response) {
                        if (response.status == 400) {
                            let bodyText = response.bodyText
                            bodyText = JSON.parse(bodyText)
                            this.alertNotification("top", "right", "danger", bodyText["message"])
                        } else if (response.status == "true") {
                            let model = response.model[0]
                            model.personal_details = JSON.parse(model.personal_details)
                            model.location_details = JSON.parse(model.location_details)
                            model.payment_details = JSON.parse(model.payment_details)
                            model.services = JSON.parse(model.services)
                            this.model = model

                        }
                        else {
                            this.alertNotification("top", "right", "danger", response.statusText)
                        }
                    }
                    else {
                        this.alertNotification("top", "right", "danger", "We are unable to fetch info from the server. Try reloading the page")
                    }

                })
        },
        getModelByUserId() {
            let headers = {
                "Authorization": "Bearer " + localStorage.getItem('token'),

            };
            this.$http.get(api_url + '/models_by_user_id?user_id=' + this.user_id, { headers })
                .then(response => {
                    return response.json()
                }, response => {
                    return response
                })
                .then(response => {
                    if (response) {
                        if (response.status == 400) {
                            let bodyText = response.bodyText
                            bodyText = JSON.parse(bodyText)
                            this.alertNotification("top", "right", "danger", bodyText["message"])
                        } else if (response.status == "true") {
                            let model = response.model[0]
                            model.personal_details = JSON.parse(model.personal_details)
                            model.location_details = JSON.parse(model.location_details)
                            model.payment_details = JSON.parse(model.payment_details)
                            model.services = JSON.parse(model.services)

                            this.model = model

                        }
                        else {
                            this.alertNotification("top", "right", "danger", response.statusText)
                        }
                    }
                    else {
                        this.alertNotification("top", "right", "danger", "We are unable to fetch info from the server. Try reloading the page")
                    }

                })
        },
        getCategories() {

            let headers = {
                "Authorization": "Bearer " + localStorage.getItem('token'),

            };
            this.$http.get(api_url + '/categories', { headers })
                .then(response => {
                    return response.json()
                }, response => {
                    return response
                })
                .then(response => {
                    if (!response.ok) {
                        if (response.status == 400) {
                            let bodyText = response.bodyText
                            bodyText = JSON.parse(bodyText)
                            this.alertNotification("top", "right", "danger", bodyText["message"])
                        } else if (response.status == "true") {
                            this.categories = response.categories
                        }
                        else {
                            this.alertNotification("top", "right", "danger", response.statusText)
                        }
                    }
                })
        },
        getPosts() {

            let headers = {
                "Authorization": "Bearer " + localStorage.getItem('token'),

            };

            this.$http.get(api_url + '/posts?model_id=' + this.id + '&type=2', { headers })
                .then(response => {
                    return response.json()
                }, response => {
                    return response
                })
                .then(response => {
                    if (!response.ok) {
                        if (response.status == 400) {
                            let bodyText = response.bodyText
                            bodyText = JSON.parse(bodyText)
                            this.alertNotification("top", "right", "danger", bodyText["message"])
                        } else if (response.status == "true") {
                            this.posts = response.posts
                        }
                        else {
                            this.alertNotification("top", "right", "danger", response.statusText)
                        }
                    }
                })
        },
        alertNotification(verticalAlign, horizontalAlign, color, message) {
            this.$notify({
                message: message,
                timeout: 30000,
                icon: 'tim-icons icon-bell-55',
                horizontalAlign: horizontalAlign,
                verticalAlign: verticalAlign,
                type: color
            });
        },
        fetchWalletBalance() {
            let headers = {
                "Authorization": "Bearer " + localStorage.getItem('token'),
            };
            this.$http.get(api_url + '/wallet/balance', { headers })
                .then(response => response.json())
                .then(response => {
                    if (response.status) {
                        this.walletBalance = response.balance;
                        this.walletCurrency = response.currency;
                    }
                });
        },
        topUpWallet() {
            let headers = {
                "Authorization": "Bearer " + localStorage.getItem('token'),
            };
            this.$http.post(api_url + '/wallet/topup', { amount: this.topUpAmount }, { headers })
                .then(response => response.json())
                .then(response => {
                    if (response.status) {
                        this.alertNotification("top", "right", "success", response.message);
                        this.fetchWalletBalance();
                    } else {
                        this.alertNotification("top", "right", "danger", response.message);
                    }
                });
        },
        withdrawWallet() {
            let headers = {
                "Authorization": "Bearer " + localStorage.getItem('token'),
            };
            this.$http.post(api_url + '/wallet/withdraw', { amount: this.withdrawAmount }, { headers })
                .then(response => response.json())
                .then(response => {
                    if (response.status) {
                        this.alertNotification("top", "right", "success", response.message);
                        this.fetchWalletBalance();
                    } else {
                        this.alertNotification("top", "right", "danger", response.message);
                    }
                });
        },
        getCategoryName(key) {
            const cat = this.categories.find(c => c.id == key);
            return cat ? cat.name : key;
        },
        openModal() {
            this.selectedService = '';
            this.serviceDuration = 0;
            this.serviceAmount = 0;
            this.showServiceModal = true;
        },
        closeModal() {
            this.showServiceModal = false;
        },
        updateAmount() {
            let rate = 0;
            if (this.selectedService) {
                rate = Number(this.model.payment_details.hourly_rate) || 0;
            }
            this.serviceAmount = rate * (this.serviceDuration || 1);
        },
        requestService() {
            if (!this.selectedService || !this.serviceDuration) {
                this.alertNotification("top", "right", "danger", "Please fill all fields.");
                return;
            }
            const data = {
                recipient_user_id: this.model.user_id,
                amount: this.serviceAmount,
                description: `Service: ${this.getCategoryName(this.selectedService)}, Duration: ${this.serviceDuration}h`
            };
            let headers = {
                "Authorization": "Bearer " + localStorage.getItem('token'),
            };
            this.$http.post(api_url + '/wallet/transfer', data, { headers })
            .then(response => response.json())
            .then(response => {
                if (response.status) {
                    this.alertNotification("top", "right", "success", "Service requested and payment sent!");
                    this.closeModal();
                } else {
                    this.alertNotification("top", "right", "danger", response.message);
                }
            });
        },
        badgeLabel(status) {
            switch (Number(status)) {
                case 2: return 'VIP';
                case 1: return 'Premium';
                default: return 'Normal';
            }
        },
        badgeClass(status) {
            switch ((status || '').toLowerCase()) {
                case 'vip': return 'badge-warning';
                case 'premium': return 'badge-primary';
                default: return 'badge-secondary';
            }
        },
        handleBadgeClick() {
            if (
                Number(this.model.account_status) === 0 &&
                String(this.loggedInUserId) === String(this.model.user_id)
            ) {
                this.showUpgradeModal = true;
            }
        },
        upgradeAccount(type, duration) {
            let headers = {
                "Authorization": "Bearer " + localStorage.getItem('token'),
            };
            this.$http.post(api_url + '/wallet/upgrade-account', { 
                    upgrade_type: type, 
                    duration: duration 
                }, { headers })
                .then(response => response.json())
                .then(response => {
                    if (response.status) {
                        this.alertNotification("top", "right", "success", response.message);
                        this.showUpgradeModal = false;
                    } else {
                        this.alertNotification("top", "right", "danger", response.message);
                    }
                });
        },
    },
    watch: {
        selectedService() {
            this.updateAmount();
        },
        serviceDuration() {
            this.updateAmount();
        }
    },
    created() {
        this.id = this.$route.params.id;
        if (this.id == null) {
            this.user_id = this.$route.params.user_id;
            this.getModelByUserId();
        }
        else{
            this.getModel();
        }
        this.getCategories();
        this.getPosts();
        this.loggedInUserId = localStorage.getItem('user_id');
        this.fetchWalletBalance();
    }
};
</script>
<style lang="scss">
.profile {
    display: table-row;
}

.profile b {
    display: table-cell;
    padding-right: 1em;

}
.modal-dark {
  background: #1e1e2f !important;
}
.badge-secondary { background: #6c757d; color: #fff; }
.badge-warning { background: #ffc107; color: #212529; }
.badge-primary { background: #007bff; color: #fff; }
</style>
<style scoped>
#edit-btn {
    color: #b448f4;
    transition: opacity 0.3s;
}
.modal-content {
  background: #1e1e2f !important;
}
.modal-dark {
  background: #1e1e2f !important;
}
</style>
  